export default __webpack_public_path__ + "static/media/pnab.b806b516.png";